import api from '../api'

// const fetchFarms = (params = {}) => {
//   return api.get('/farms', { params: { ...params } })
// }

const fetchFarms = (params = {}) => {
  return api.get('/farms', { params: { 'farmUsers.user': atob(window.localStorage.getItem('user-id')), ...params } })
}

const fetchFarmById = (id, params = {}) => {
  return api.get(`/farms/${id}`, { params: { ...params } })
}

const fetchRewardPointAmount = (id, params = {}) => {
  return api.get(`/farms/${id}/reward_point_amount`)
  //return api.get(`/farms/${id}/reward_point_amount`, { params: { ...params, toMoney: false } })
}

const fetchFarmsByCurrentUser = (params = {}) => {
  return api.get('/farms/user', { params: { ...params } })
}

const fetchFarmsByCurrentUserImproved = (params = {}) => {
  return api.get('/farm_users', { params: { ...params } })
}

const fetchFarmsByUuid = (id, params = {}) => {
  return api.get(`/farms/${id}`, { params: { ...params } })
}

const createFarm = (body = {}) => {
  return api.post('/farms', body)
}

const updateFarm = (id, body = {}) => {
  return api.put(`/farms/${id}`, body)
}

const deleteFarm = (id) => {
  return api.delete(`/farms/${id}`)
}

const fetchFarmTokensPartners = (params = {}) => {
  return api.get('/farm_partner_tokens/partnerTokens', { params: { farm: atob(window.localStorage.getItem('farm-id')), ...params } })
}

export {
  fetchFarms,
  fetchRewardPointAmount,
  fetchFarmsByCurrentUser,
  fetchFarmsByCurrentUserImproved,
  fetchFarmsByUuid,
  createFarm,
  updateFarm,
  deleteFarm,
  fetchFarmById,
  fetchFarmTokensPartners
}
